import layout from './Crontab.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import CrontabViewModel from '@/ViewModels/Controls/CrontabViewModel';
import CrontabWindow from '@/Controls/CrontabWindow';

export default class Crontab extends Control {
    private jQueryControl: JQuery;
    private crontabWindow: CrontabWindow;

    public constructor(private viewModel: CrontabViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        
        this.jQueryControl = this.element || $('<div>')
        this.widget(null);

        this.applyTemplate(layout, this.jQueryControl);
        this.crontabWindow = new CrontabWindow(this.viewModel.cronJobWindow);

        const tuple = this.crontabWindow.getTuple();
        tuple.control.appendTo(this.jQueryControl);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget) {
        this.applyBindings(this.jQueryControl, {
            controlName: 'crontab',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            tooltip: this.viewModel.tooltip,
            
            locator: this.viewModel.locator,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });
    }
}

ComponentManager.setControl('Crontab', Crontab, 'RADPresentation.HTMLClient.DefaultViewExtensions');